import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHealingSelected = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 24,
		cy: 24,
		r: 24,
		fill: "#16a085"
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 24,
		cy: 24,
		r: 8,
		fill: "white"
	})]
});
export default SvgHealingSelected;
